export enum CmsType {
    Kontent
}
